import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const SectionContainer = styled.section`
  padding: 60px 0 80px;
  background: #474545;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    padding: 40px 0 60px;
    overflow-x: hidden;
  }
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const DevicesWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const ImageContainer = styled(motion.div)`
  width: 100%;
  max-width: 100%;
  
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const DesktopImageContainer = styled(ImageContainer)`
  max-width: 1200px;
  width: 100%;
  
  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const AppScreenshots = () => {
  return (
    <SectionContainer>
      <Container>
        <DevicesWrapper>
          <DesktopImageContainer
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_628a8393-d775-410a-a2a2-f298aaa6ef5d/artifacts/37n3qzh5_optimized-z7j5pkox_Untitled%20design.webp" 
              alt="f01i.ai Desktop Application - AI Crypto Trading Bot Builder" 
            />
          </DesktopImageContainer>
        </DevicesWrapper>
      </Container>
    </SectionContainer>
  );
};

export default AppScreenshots;
